module.exports = __webpack_public_path__ + "assets/img/mecha-btn-70cc7141.png";